export const RecruitmentType = {
    MAILING: {id: 0, name: "Mailing", value: "MAILING"},
    PHONING: {id: 1, name: "Phoning", value: "PHONING"},
    WEBSITE: {id: 2, name: "Site internet", value: "WEBSITE"},
    WORD_OF_MOUTH: {id: 3, name: "Bouche à oreille", value: "WORD_OF_MOUTH"},
    CONGRESS: {id: 4, name: "Congrés", value: "CONGRESS"},
}